<template>
    <div
            class="s-input"
            :class="{'error' : item.tips,'half':half}">
        <!--label-->
        <div class="s-input-label" :style="{width:labelWidth}" :class="{must:item.must}">
            {{item.label}}：
        </div>
        <!--input主体-->
        <div class="s-input-cont">
            <!--输入框-->
            <template v-if="item.type === 'input'">
                <Input
                        :prefix="prefix"
                        :size="size"
                        v-model="item.value"
                        :disabled="disabled"
                        :readonly="readonly"
                        :maxlength="maxlength"
                        :clearable="clearable"
                        :type="item.inputType"
                        :placeholder="placeholder ? placeholder:'请录入'+ item.label"
                        @on-blur="inputBlur"
                        @on-change="inputChange">
                    <span v-if="item.append" slot="append">{{item.append}}</span>
                    <span v-if="item.prepend" slot="prepend">{{item.prepend}}</span>
                </Input>
            </template>
            <!--textarea-->
            <template v-if="item.type === 'textarea'">
                <Input
                        :prefix="prefix"
                        :size="size"
                        v-model="item.value"
                        :disabled="disabled"
                        type="textarea"
                        :readonly="readonly"
                        :maxlength="maxlength"
                        :clearable="clearable"
                        :autosize="autosize"
                        :placeholder="placeholder ? placeholder:'请录入'+ item.label"
                        @on-blur="inputBlur"
                        @on-change="inputChange">
                </Input>
            </template>
            <!--本地枚举-->
            <template v-if="item.type === 'mj'">
                <Select
                        :size="size"
                        :disabled="disabled"
                        :clearable="clearable"
                        @on-change="inputChange"
                        :placeholder="placeholder ? placeholder:'请录入'+ item.label"
                        v-model="item.value">
                    <Option
                            v-for="opt in mjJson[item.mj]"
                            :value="opt.code"
                            :key="opt.code">
                        {{opt.code + ' | ' + opt.name}}
                    </Option>
                </Select>
            </template>
            <!--自定义选择框-->
            <template v-if="item.type === 'select'">
                <Select
                        :size="size"
                        :disabled="disabled"
                        :clearable="clearable"
                        @on-change="inputChange"
                        @on-open-change=""
                        :placeholder="placeholder!=='' ? placeholder:'请选择'+ item.label"
                        v-model="item.value">
                    <Option
                            v-for="opt in item.select"
                            :value="opt.code"
                            :disabled="opt.disabled"
                            :key="opt.code">
                        <template v-if="opt.code === opt.name">
                            {{ opt.code }}
                        </template>
                        <template v-else>
                            {{opt.code + ' | ' + opt.name }}
                        </template>
                    </Option>
                </Select>
            </template>
            <!--日期选择框-->
            <template v-if="item.type === 'date'">
                <DatePicker
                        v-model="item.value"
                        :type="item.dateType"
                        :disabled="disabled"
                        :options="item.options"
                        :clearable="clearable"
                        @on-open-change="inputBlur"
                        @on-change="inputChange"
                        :placeholder="placeholder ? placeholder:'请选择'+ item.label">
                </DatePicker>
            </template>
            <!--radio/单选-->
            <template v-if="item.type === 'radio'">
                <RadioGroup v-model="item.value" @on-change="inputChange">
                    <Radio v-for="radio in item.radio" :key="radio.code" :label="radio.code" :disabled="radio.disabled">
                        <Icon v-if="radio.icon" :type="radio.icon"></Icon>
                        <span>{{radio.name}}</span>
                    </Radio>
                </RadioGroup>
            </template>
        </div>
        <!--错误提示-->
        <div class="s-input-error" :style="{left:labelWidth}" v-if="item.tips">
            <template v-if="item.tips === 'error'">
                {{item.error || item.label+ '格式不正确！'}}
            </template>
            <template v-else-if="item.tips === 'empty'">
                {{item.empty || item.label+ '不能为空！'}}
            </template>

        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    // 本地枚举
    import mjJson from '../../static/js/meiju.json'
    // s-input 验证
    import verifySItem from './verifySItem'

    export default {
        name: 'sInput',
        props: ['item', 'size', 'half', 'labelWidth'],
        data() {
            return {
                mjJson: mjJson,
                // 输入框前缀Icon
                prefix: '',
                // 输入框后缀Icon
                suffix: '',
                // 提示
                placeholder: '',
                // 禁止选择
                disabled: false,
                // 只读
                readonly: false,
                // 是否添加清除按钮
                clearable: false,
                maxlength: null,
                // rows:{
                //   minRows:1
                // }
            }
        },
        created() {
            this.setAttr();
        },
        mounted() {
        },
        watch: {
            item(val) {
                this.item = val;
                this.setAttr();
            }
        },
        methods: {
            /**
             * 设置属性值
             */
            setAttr() {
                // 赋值属性字段
                let attr = ['prefix', 'suffix', 'placeholder', 'disabled', 'maxlength', 'readonly', 'clearable', 'autosize'];
                attr.map((key) => {
                    this[key] = this.item[key]
                })
            },
            /**
             * input on-change事件
             */
            inputChange() {
                this.item = verifySItem(this.item);
                // 刷新数据
                this.$forceUpdate();
                // 通信父级 参数
                this.$emit('update:item', this.item);
                // 通信父级 on-change事件
                this.$emit('on-change', this.item);
                this.forceUpdate();
            },
            /**
             * input on-blur事件
             */
            inputBlur() {
                this.inputChange();
                // 通信父级 on-blur事件
                this.$emit('on-blur', this.item)
            },
            /**
             * 更新渲染数据
             */
            forceUpdate() {
                this.$forceUpdate();
            }
        }
    }
</script>

<style lang="scss">
    @import "index";
</style>



// WEBPACK FOOTER //
// src/components/s-input/sInput.vue